import { useEffect, useState } from 'react';

/**
 * Returns `value` only after it has stopped changing for `delayMs`. The first value is
 * returned immediately, so nothing is delayed on first render. Used to avoid firing a
 * request for every intermediate step while someone is still picking a date.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
